const KEY = "nofap27_streak_v1";
const MS_DAY = 24 * 60 * 60 * 1000;

function defaultState() {
  return {
    currentStartAt: null, // timestamp (ms)
    history: [], // [{ startAt, endAt, days }]
    updatedAt: Date.now(),
  };
}

export function loadStreak() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultState();
    const data = JSON.parse(raw);
    return { ...defaultState(), ...data };
  } catch (e) {
    console.error("Failed to parse streak. Resetting.", e);
    return defaultState();
  }
}

function save(st) {
  const toSave = { ...st, updatedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(toSave));
  return toSave;
}

export function startStreak(startAt = Date.now()) {
  const s = loadStreak();
  if (s.currentStartAt) return s; // already active
  s.currentStartAt = startAt;
  return save(s);
}

export function endStreak(endAt = Date.now()) {
  const s = loadStreak();
  if (!s.currentStartAt) return s; // nothing to end
  const days = computeCompletedDays(s.currentStartAt, endAt);
  s.history = [...(s.history || []), { startAt: s.currentStartAt, endAt, days }];
  s.currentStartAt = null;
  return save(s);
}

export function resetStreak() {
  return save(defaultState());
}

export function computeCompletedDays(startAt, nowTs = Date.now()) {
  if (!startAt) return 0;
  const diff = Math.max(0, nowTs - startAt);
  return Math.floor(diff / MS_DAY); // completed days only
}

export function computeStats(st) {
  const hist = st.history || [];
  const totalStreaks = hist.length;
  const last = totalStreaks ? hist[totalStreaks - 1].days : 0;
  const best = hist.reduce((m, h) => Math.max(m, h.days || 0), 0);
  const sum = hist.reduce((acc, h) => acc + (h.days || 0), 0);
  const avg = totalStreaks ? Math.round(sum / totalStreaks) : 0;
  return { last, best, avg, totalStreaks };
}

export function nextMilestone(currentDays) {
  const milestones = [7, 14, 30, 60, 90, 180, 365];
  for (let m of milestones) {
    if (currentDays < m) return m;
  }
  return null; // beyond biggest milestone
}